import { useFetch } from './useFetch';
import type { AsyncState } from './useFetch';
import { fetchProjects } from '@/api/projects';
import type { ProjectsQuery } from '@/api/projects';
import type { ProjectListResponse, Project } from '@/api/types';
import { fetchProject, fetchProjectMembers } from '@/api/projects';
import type { ProjectMembersResponse } from '@/api/types';

export function useProjects(query: ProjectsQuery = {}): AsyncState<ProjectListResponse> {
  // 직렬화 키로 의존성 안정화 — 부동 객체로 매번 재호출되는 것 방지.
  const key = JSON.stringify(query);
  return useFetch<ProjectListResponse>((signal) => fetchProjects(query, signal), [key]);
}

// 인자 명은 project_id — 5자리 숫자 ID (utils.apps.project_id). 'all' literal은 grant scope에만 쓰이고 라우팅에는 쓰이지 않음.
export function useProject(projectId: string | undefined): AsyncState<Project> {
  return useFetch<Project>(
    (signal) => {
      if (!projectId) return Promise.reject(new Error('project_id is required'));
      return fetchProject(projectId, signal);
    },
    [projectId ?? ''],
  );
}

export function useProjectMembers(
  projectId: string | undefined,
): AsyncState<ProjectMembersResponse> {
  return useFetch<ProjectMembersResponse>(
    (signal) => {
      if (!projectId) return Promise.reject(new Error('project_id is required'));
      return fetchProjectMembers(projectId, signal);
    },
    [projectId ?? ''],
  );
}
